import {
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { t } from 'i18next';
import { createGetEstimatedCostandEffortOptions } from '../../queries/estimateQueries';
import { isEmptyObject } from '../../utils';
import { ErrorAlert } from '../atoms/Alert-message';
import PickDate from '../atoms/pick-date';

function EstimatesSummaryTable(props) {
  const {
    pecrId,
    siteId,
    targetDate,
    currency,
    selectedDate,
    setSelectedDate,
    apiConfig,
    StyledTableCell,
    StyledTableRow,
    disabled,
  } = props;

  const { data, isLoading, isError, error } = useQuery(
    createGetEstimatedCostandEffortOptions(
      {
        pecrId,
        siteId,
        url: apiConfig.uiURL,
      },
      { staleTime: 1000 * 60 * 5 } // 5 minutes stale time
    )
  );

  //might want to filter by SourceTable === GRAND TOTAL but it will always be last entry
  let singleEstimate = data && data.length ? data[data.length - 1] : {};
  if (isLoading) return <CircularProgress />;
  if (isError) {
    return <ErrorAlert message={error.message} />;
  }

  return (
    <TableContainer component={Paper}>
      {singleEstimate && !isEmptyObject(singleEstimate) && targetDate && (
        <Table sx={{ minWidth: 100 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell align="center">
                {t('Total_Effort_Hours')}
              </StyledTableCell>
              <StyledTableCell align="center">
                {t('Total_Costs_Currency')}
              </StyledTableCell>
              <StyledTableCell align="center">
                {t('Target_date_for_execution')}
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <StyledTableRow>
              <StyledTableCell align="center">
                {singleEstimate.TotalActualEffort || 0}
              </StyledTableCell>
              <StyledTableCell align="center">{`${
                singleEstimate.TotalActualCost ?? ''
              } ${currency ?? ''}`}</StyledTableCell>
              <StyledTableCell align="center">
                <PickDate
                  value={selectedDate}
                  setValue={newDate => setSelectedDate(newDate)}
                  disabled={disabled}
                />
              </StyledTableCell>
            </StyledTableRow>
          </TableBody>
        </Table>
      )}
    </TableContainer>
  );
}

export default EstimatesSummaryTable;
